export * from './LocationResultsListsV2Collapsed';
